import { FormattedMessage } from 'react-intl'
import { Text, View } from 'react-native'
import styled from 'styled-components'
import commonMessages from '@flix/common/domain/video/messages'
import Icon from '@flix/common/elements/images/Icon'
import { media, useMediaIs } from '@flix/common/style/media'
import messages from './messages'

const Layout = styled(View)`
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

const IconView = styled(View)`
  padding: ${(props) => props.theme.spacing.medium}px;
`

const Title = styled(Text)`
  font-size: ${(props) => props.theme.fontSizes.medium}px;
  text-align: center;
  color: ${(props) => props.theme.colors.text};
  margin-bottom: ${(props) => props.theme.spacing.larger}px;

  ${media.sm`
    font-size: ${(props) => props.theme.fontSizes.larger}px;
  `}
`

const Body = styled(Title)`
  max-width: 90%;
  font-weight: ${(props) => props.theme.fontWeights.normal};
  font-size: ${(props) => props.theme.fontSizes.medium}px;
  margin-bottom: ${(props) => props.theme.spacing.lg}px;
`

const Support = styled(Body)`
  margin-bottom: ${(props) => props.theme.spacing.lg * 1.5}px;
`

export const OverviewPlayerError = () => {
  const sm = useMediaIs('sm')
  return (
    <Layout>
      <IconView>
        <Icon name="exclamation" scale={!sm ? 1 : 1.6} />
      </IconView>
      <Title>
        <FormattedMessage {...commonMessages.channelPlayerErrorTitle} />
      </Title>
      <Body>
        <FormattedMessage {...commonMessages.channelPlayerErrorBody} />
      </Body>
      <Support>
        <FormattedMessage {...messages.unexpectedSupport} />
      </Support>
    </Layout>
  )
}
